<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    width="1340px"
    custom-class="all-major-dialog"
  >
    <!-- 各批次列表（同时承载院校信息头部，以便院校名 sticky 吸顶） -->
    <div v-loading="loading" class="batch-list-wrap">
      <!-- 院校信息头部（与列表共用同一个滚动容器，院校名 sticky） -->
      <div class="school-name-row">
        <span class="school-name">{{ schoolInfo.schoolName || '--' }}</span>
        <span class="school-name-icons">
          <img v-if="schoolInfo.limitFlag" class="tag-limit-school" src="~@/assets/images/icon_shouxian.png" alt="icon">
          <img
            v-if="schoolInfo.code"
            class="school-name-icon"
            width="22"
            height="18"
            src="~@/assets/images/icon_zhu.png"
            alt="icon"
            style="cursor: pointer;"
            @click="$emit('introduceSchool', schoolInfo.code)"
          >
        </span>
      </div>
      <div v-if="hasTags" class="school-tags">
        <span>{{ schoolInfo.level }}</span>
        <span>{{ schoolInfo.city }}</span>
        <span>{{ schoolInfo.manager }}</span>
        <span v-if="schoolInfo.levelMsg">{{ schoolInfo.levelMsg }}</span>
      </div>
      <div class="school-extra">
        <span v-if="schoolInfo.majorPlan" :class="['extra-item', isMajorPlanHighlight ? 'txt-red' : '']">{{ schoolInfo.majorPlan }}</span>
        <span v-if="schoolInfo.rateGraduate" class="extra-item">{{ schoolInfo.rateGraduate }}</span>
      </div>

      <div v-for="batch in batchList" :key="batch.batchName" class="batch-block">
      <div
        v-for="group in batch.groupList"
        :key="group.code + '-' + group.groupCode"
        class="group-block"
      >
        <el-table
          :data="[group]"
          :row-key="row => row.code + '-' + row.groupCode"
          :expand-row-keys="expandedRowKeys"
          class="school-table"
        >
        <!-- 录取概率 / 冲稳保 -->
        <el-table-column label="录取概率" align="center" width="96">
          <template slot-scope="scope">
            <strong class="probability-text">{{ scope.row.probability }}</strong>
            <el-tag v-if="scope.row.probabilityName" size="mini" :style="probabilityStyle(scope.row.probabilityName)" effect="dark">
              {{ scope.row.probabilityName }}
            </el-tag>
          </template>
        </el-table-column>
        <!-- 招生代码（提前批为“院校代码”） -->
        <el-table-column :label="batch.isAdvance ? '院校代码' : '招生代码'" align="center" width="110">
          <template slot-scope="scope">
            <span
              class="font-strong code-toggle"
              :class="{ 'code-highlight': scope.row.code + '-' + scope.row.groupCode === highlightCode }"
              @click.stop="toggleGroup(scope.row)"
            >
              {{ scope.row.code }}-{{ scope.row.groupCode }}
              <i
                :class="isGroupExpanded(scope.row) ? 'el-icon-caret-bottom' : 'el-icon-caret-right'"
                style="color: #ccc; margin-left: 4px;"
              ></i>
            </span>
          </template>
        </el-table-column>

        <!-- 专业数（字段 majorNum，由数据层写入） -->
        <el-table-column align="center" prop="groupCode" label="专业数" width="66">
          <template slot-scope="scope">
            <span class="font-strong">{{ scope.row.majorNum }}</span>
          </template>
        </el-table-column>

        <!-- 再选要求 -->
        <el-table-column prop="subject" label="再选要求" align="center" width="70">
          <template slot="header">
            <div class="th-2line">
              <div>再选</div>
              <div>要求</div>
            </div>
          </template>
        </el-table-column>

        <!-- 类别 -->
        <el-table-column label="类别" align="center" width="62">
          <template slot-scope="scope">
            <span :class="batch.isAdvance ? '' : (scope.row.recruitType === '中外合办' ? 'txt-red' : '')">
              {{ batch.isAdvance ? scope.row.schoolCate : scope.row.recruitType }}
            </span>
          </template>
        </el-table-column>

        <!-- 计划数|录取数 -->
        <el-table-column label="计划数|录取数" align="center">
          <el-table-column :label="String(yearNow - 2)" align="center" min-width="80">
            <template slot-scope="scope">{{ scope.row.toudang2019 }}</template>
          </el-table-column>
          <el-table-column :label="String(yearNow - 1)" align="center" min-width="80">
            <template slot-scope="scope">{{ scope.row.toudang2020 }}</template>
          </el-table-column>
          <el-table-column :label="String(yearNow)" align="center" min-width="80">
            <template slot-scope="scope">
              <span class="font-strong">{{ scope.row.toudang2021 }}</span>
            </template>
          </el-table-column>
        </el-table-column>

        <!-- 录取线（含征集） -->
        <el-table-column label="录取线（含征集）" align="center">
          <el-table-column :label="String(yearNow - 2)" align="center" min-width="76">
            <template slot-scope="scope">{{ scope.row.shiftLine2019 }}</template>
          </el-table-column>
          <el-table-column :label="String(yearNow - 1)" align="center" min-width="76">
            <template slot-scope="scope">{{ scope.row.shiftLine2020 }}</template>
          </el-table-column>
          <el-table-column :label="String(yearNow)" align="center" min-width="76">
            <template slot-scope="scope">
              <span class="font-strong">{{ scope.row.shiftLine2021 }}</span>
            </template>
          </el-table-column>
        </el-table-column>

        <!-- 录取位次 -->
        <el-table-column label="录取位次" align="center">
          <el-table-column :label="String(yearNow - 2)" align="center" min-width="62">
            <template slot-scope="scope">{{ scope.row.ranking2019 }}</template>
          </el-table-column>
          <el-table-column :label="String(yearNow - 1)" align="center" min-width="62">
            <template slot-scope="scope">{{ scope.row.ranking2020 }}</template>
          </el-table-column>
          <el-table-column :label="String(yearNow)" align="center" min-width="62">
            <template slot-scope="scope">
              <span class="font-strong">{{ scope.row.ranking2021 }}</span>
            </template>
          </el-table-column>
        </el-table-column>

        <!-- 当年计划 -->
        <el-table-column :label="yearPlan + '计划'" align="center" width="64">
          <template slot="header" slot-scope="{}">
            <div class="th-2line">
              <div>{{ yearPlan }}</div>
              <div>计划</div>
            </div>
          </template>
          <template slot-scope="scope">
            <span v-if="scope.row.plan2022 > scope.row.plan2021" class="icon-top">
              {{ scope.row.plan2022 }}<i>↑</i>
            </span>
            <span v-else-if="scope.row.plan2021 > scope.row.plan2022" class="icon-bottom">
              {{ scope.row.plan2022 }}<i>↓</i>
            </span>
            <span v-else>{{ scope.row.plan2022 }}</span>
          </template>
        </el-table-column>

        <!-- 填报（参照 seniorSchool：选择/已选N） -->
        <el-table-column align="center" prop="zy" label="填报" width="90">
          <template slot-scope="scope">
            <el-checkbox @change="(value) => $emit('schemeChange', value, scope.row)" v-model="scope.row._schemeChecked">
              {{ scope.row._schemeChecked ? `已选${scope.row.schemeNum}` : '选择' }}
            </el-checkbox>
          </template>
        </el-table-column>

        <!-- 默认展开：专业表 -->
        <el-table-column type="expand" width="1">
          <template slot-scope="props">
            <el-table :data="props.row.children1 || []" class="major-table">
              <!-- 录取概率 / 冲稳保 -->
              <el-table-column label="录取概率" align="center" width="96">
                <template slot-scope="scope">
                  <strong class="probability-text">{{ scope.row.probability }}</strong>
                  <el-tag v-if="scope.row.probabilityName" size="mini" :style="probabilityStyle(scope.row.probabilityName)" effect="dark">
                    {{ scope.row.probabilityName }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column label="专业代码" width="78">
                <template slot-scope="scope">
                  <div class="major-code-row">
                    <div class="major-code-cell">
                      <span class="major-code-num">{{ scope.row.majorCode }}</span>
                      <img v-if="scope.row.limitFlag" class="tag-limit" src="~@/assets/images/icon_shouxian.png" alt="icon">
                    </div>
                    <img v-if="scope.row.isNewMajor == 1" src="~@/assets/images/icon-new-major.png" class="tag-new">
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="专业名称(包含专业及等级排名)" min-width="139">
                <template slot-scope="scope">
                  <el-row type="flex" style="text-align: left; align-items: center;">
                    <span style="font-size: 14px; margin-left: 5px; flex: 1;">{{ scope.row.majorName }}</span>
                    <img v-if="scope.row.majorDesc" width="22" height="18" src="~@/assets/images/icon_zhu.png" alt="icon" style="cursor: pointer; margin-left: 10px;" @click="$emit('introduceMajor', scope.row.majorDesc)">
                  </el-row>
                </template>
              </el-table-column>
              <el-table-column label="计划数 / 录取数 | 最高分 / 平均分 / 最低分 | 最高位次-最低位次" align="center">
                <el-table-column :label="String(yearMajorNow - 2)" align="center" min-width="151">
                  <template slot-scope="scope">{{ scope.row.msg2015 }}</template>
                </el-table-column>
                <el-table-column :label="String(yearMajorNow - 1)" align="center" min-width="151">
                  <template slot-scope="scope">{{ scope.row.msg2016 }}</template>
                </el-table-column>
                <el-table-column :label="String(yearMajorNow)" align="center" min-width="151">
                  <template slot-scope="scope">{{ scope.row.msg2017 }}</template>
                </el-table-column>
              </el-table-column>
              <el-table-column :label="yearMajorPlan + '计划'" align="center" width="64">
                <template slot="header" slot-scope="{}">
                  <div class="th-2line">
                    <div>{{ yearMajorPlan }}</div>
                    <div>计划</div>
                  </div>
                </template>
                <template slot-scope="scope">
                  <span v-if="scope.row.plan2018 > scope.row.plan2017" class="icon-top">{{ scope.row.plan2018 }}↑</span>
                  <span v-else-if="scope.row.plan2017 > scope.row.plan2018" class="icon-bottom">{{ scope.row.plan2018 }}↓</span>
                  <span v-else>{{ scope.row.plan2018 }}</span>
                </template>
              </el-table-column>

              <!-- 操作（参照 seniorSchool：选择/已选sort + 下拉选择专业序） -->
              <el-table-column label="操作" style="padding: 0;" align="center" width="90">
                <template slot-scope="scope">
                  <el-dropdown trigger="click" style="margin: 0;padding: 0;">
                    <span class="el-dropdown-link" :class="scope.row.sort ? 'scheme' : 'not-scheme'" style="font-size: 14px;margin: 0;cursor: pointer;">
                      {{ scope.row.sort ? scope.row.sort : '选择' }}
                    </span>
                    <i class="el-icon-caret-bottom"></i>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item v-for="(item, index) in majorList" :key="index" :command="item.label" style="padding: 0;text-align: center;">
                        <span
                          :style="majorDisabled.includes(scope.row.code + '_' + scope.row.groupCode + '_' + item.label) ? 'color: #c0c4cc;' : ''"
                          :class="majorDisabled.includes(scope.row.code + '_' + scope.row.groupCode + '_' + item.label) ? 'is-disabled' : ''"
                          @click="!majorDisabled.includes(scope.row.code + '_' + scope.row.groupCode + '_' + item.label) ? $emit('majorChange', props.row, scope.row, item.label) : () => {}"
                          style="width: 60px;padding: 10px;display: inline-block;cursor: pointer;">{{ item.label }}</span>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-table-column>
        </el-table>
      </div>
    </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取消</el-button>
      <el-button type="primary" @click="confirmDialog">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'allMajorDesginDialog',
  // 弹窗期间对院校 / 专业的选择是否最终确认。
  // true  -> 关闭时父组件保留弹窗内所做的改动
  // false -> 关闭时父组件按原始方案恢复（取消语义）
  data () {
    return {
      confirmed: false,
      // 当前已展开的 group key 列表（默认全部收起）
      expandedRowKeys: []
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    // 加载中状态（数据拉取期间显示 loading）
    loading: {
      type: Boolean,
      default: false
    },
    // 需要高亮的招生代码（格式 `${code}-${groupCode}`），用于标记当前点击的院校专业组
    highlightCode: {
      type: String,
      default: ''
    },
    // 院校顶部信息：{ schoolName, level, city, manager, levelMsg, majorPlan, rateGraduate }
    schoolInfo: {
      type: Object,
      default: () => ({})
    },
    // 批次列表：[{ batchName, isAdvance, groupList: [{ ...字段, children1: [...] }] }]
    batchList: {
      type: Array,
      default: () => []
    },
    // 数据年份（用于表头年份显示）
    nowYear: {
      type: Number,
      default: 2025
    },
    // 计划年份
    planYear: {
      type: Number,
      default: 2026
    },
    // 专业表数据年份（展开的专业子表表头年份显示）
    majorNowYear: {
      type: Number,
      default: 2025
    },
    // 专业表计划年份（展开的专业子表“计划”列表头显示）
    majorPlanYear: {
      type: Number,
      default: 2026
    },
    // 已选方案专业下拉选项（来自父组件，与 seniorSchool 列表一致）
    majorList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },
    hasTags() {
      const info = this.schoolInfo || {}
      return !!(info.level || info.city || info.manager || info.levelMsg)
    },
    isMajorPlanHighlight() {
      const plan = this.schoolInfo.majorPlan
      return plan === '专业清' || plan === '一专再分'
    },
    yearNow() {
      const y = Number(this.nowYear)
      return y && !isNaN(y) ? y : 2025
    },
    yearPlan() {
      const y = Number(this.planYear)
      return y && !isNaN(y) ? y : 2026
    },
    yearMajorNow() {
      const y = Number(this.majorNowYear)
      return y && !isNaN(y) ? y : this.yearNow
    },
    yearMajorPlan() {
      const y = Number(this.majorPlanYear)
      return y && !isNaN(y) ? y : this.yearPlan
    },
    // 弹窗上下文内的 majorDisabled：从 batchList 所有 group 的 children1 中 sort 字段汇总
    // 等价于 seniorSchool 中 code_groupCode_sort 列表
    majorDisabled() {
      const keys = []
      this.batchList.forEach(batch => {
        (batch.groupList || []).forEach(group => {
          (group.children1 || []).forEach(o => {
            if (!['', null, undefined].includes(o.sort)) {
              keys.push(o.code + '_' + o.groupCode + '_' + o.sort)
            }
          })
        })
      })
      return keys
    }
  },
  methods: {
    closeDialog() {
      // 由 :visible.sync 触发 visible 变为 false，watch.visible 统一处理 close 事件
      this.$emit('update:visible', false)
    },
    // 点击"确定"：标记为已确认，关闭弹窗，父组件保留弹窗期间的方案选择
    confirmDialog() {
      this.confirmed = true
      this.closeDialog()
    },
    // 冲稳保标签配色（参考 ProbabilityTea.vue）
    probabilityStyle(name) {
      const color = { '冲': 'red', '稳': 'rgb(198, 95, 16)', '保': 'green' }[name]
      return { background: color, borderColor: color }
    },
    // 切换某个 group 的专业表展开/收起（手风琴：同一时间只有一个展开）
    toggleGroup(group) {
      const key = group.code + '-' + group.groupCode
      const idx = this.expandedRowKeys.indexOf(key)
      if (idx >= 0) {
        // 已展开 → 收起
        this.expandedRowKeys.splice(idx, 1)
      } else {
        // 未展开 → 清空其他，只展开当前
        this.expandedRowKeys = [key]
      }
    },
    isGroupExpanded(group) {
      return this.expandedRowKeys.indexOf(group.code + '-' + group.groupCode) >= 0
    }
  },
  watch: {
    // 弹窗从显示变为隐藏时，统一 emit('close', confirmed)，
    // 覆盖：右上 X、ESC、按钮触发关闭 等所有路径，只触发一次
    visible(val, oldVal) {
      if (oldVal === true && val === false) {
        this.$emit('close', this.confirmed)
        this.confirmed = false
        this.expandedRowKeys = []
      } else if (oldVal === false && val === true) {
        // 重新打开时确保收起（弹窗可能在组件销毁前不重置）
        this.expandedRowKeys = []
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
/* 院校名：吸顶在 .batch-list-wrap（滚动容器）顶部 */
.school-name-row {
  display: flex;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  padding: 14px 24px 10px;
  border-bottom: 1px solid #eee;
  margin: 0;
  position: sticky;
  top: 0;
  z-index: 5;
  background: #fff;

  .school-name {
    font-size: 22px;
    font-weight: 700;
    color: #1f1f1f;
  }

  .school-name-icons {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    margin-left: 5px;

    .tag-limit-school {
      /* 重置 common.styl 全局 position: absolute */
      position: relative;
      top: auto;
      left: auto;
      width: 18px;
      height: 18px;
      vertical-align: middle;
    }

    .school-name-icon {
      vertical-align: middle;
    }
  }
}

.school-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  font-size: 14px;
  color: #666;
  margin-bottom: 8px;
  padding: 10px 24px 0;

  span {
    position: relative;
    &::after {
      content: '';
      position: absolute;
      right: -8px;
      top: 4px;
      bottom: 4px;
      width: 1px;
      background: #ddd;
    }
    &:last-child::after {
      display: none;
    }
  }
}

.school-extra {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  font-size: 14px;
  color: #333;
  padding: 0 24px 16px;
  border-bottom: 1px solid #eee;

  .extra-item {
    display: inline-flex;
    align-items: center;
  }

  .extra-label {
    font-style: normal;
    color: #999;
    margin-right: 4px;
  }
}

/* 列表 + 院校信息头部 共用同一个滚动容器 */
.batch-list-wrap {
  min-height: 200px;
  max-height: 70vh;
  overflow-y: auto;
  padding: 0 24px 24px;
}

.batch-block {
  margin-bottom: 22px;

  &:last-child {
    margin-bottom: 0;
  }
}

/* 每个专业组单独一张表，组间上下间距 */
.group-block {
  margin-bottom: 16px;

  &:last-child {
    margin-bottom: 0;
  }
}

/* 隐藏展开按钮的箭头 */
.school-table /deep/ .el-table__expand-icon {
  display: none;
}

/* 院校表头背景色 + 高度缩小（与 indexTeacher 一致） */
.school-table /deep/ .el-table__header-wrapper th {
  background-color: #f0f0f0;
  padding: 6px 0;
}

/* 院校表头文字颜色（加深） */
.school-table /deep/ .el-table__header-wrapper th .cell {
  color: #303133;
  font-weight: 600;
}

/* 院校表行背景色 */
.school-table /deep/ .el-table__body-wrapper td {
  background-color: #fff;
}

/* 院校表 hover 保持白底（去掉 hover 变色） */
.school-table /deep/ .el-table__body tr:hover > td {
  background-color: #fff !important;
}

/* 专业表头背景色（覆盖院校表头，须置于其后的规则） */
.major-table /deep/ .el-table__header-wrapper th {
  background-color: rgba(252, 102, 33, 0.3);
  padding: 6px 0;
}

/* 专业表头文字颜色（加深） */
.major-table /deep/ .el-table__header-wrapper th .cell {
  color: #303133 !important;
  font-weight: 600;
}

/* 专业表行背景色 */
.major-table /deep/ .el-table__body-wrapper td {
  background-color: rgba(252, 102, 33, 0.15);
}

/* 专业表 hover 保持原背景色（去掉 hover 变色） */
.major-table /deep/ .el-table__body tr:hover > td {
  background-color: rgba(252, 102, 33, 0.15) !important;
}

.major-table {
  margin: 0;
  border: 1px solid #ebeef5;
  border-radius: 4px;
}

/* 院校表与展开行（专业表）之间的间距去掉 */
.school-table /deep/ .el-table__expanded-cell {
  padding: 0;
}

.font-strong {
  font-weight: bold;
}

/* 当前点击的院校招生代码高亮（主题色） */
.code-highlight {
  color: var(--primaryColor);
}

/* 招生代码列：可点击切换展开/收起 */
.code-toggle {
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
}

.icon-top {
  color: #39B830;

  i {
    font-style: normal;
    margin-left: 2px;
  }
}

.icon-bottom {
  color: #f56c6c;

  i {
    font-style: normal;
    margin-left: 2px;
  }
}

.txt-red {
  color: #f00;
}

/* 表头两行：用于再选要求、年份计划 列 */
.th-2line {
  line-height: 1.15;
}

.th-2line > div {
  display: block;
}

.major-code-row {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 2px 4px;
  row-gap: 2px;
}

.major-code-cell {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;

  .major-code-num {
    font-weight: 600;
    color: #303133;
    line-height: 18px;
    display: inline-flex;
    align-items: center;
  }

  .tag-limit {
    width: 18px;
    height: 18px;
    margin-left: 8px;
    vertical-align: middle;
  }
}

.tag-new {
  width: 31px;
  height: auto;
  vertical-align: middle;
}

/* 录取概率文字（在 strong 中） */
.probability-text {
  display: inline-block;
  margin-right: 4px;
  font-weight: 600;
}

/* 填报 / 操作列文案样式（参照 seniorSchool） */
.scheme {
  color: var(--primaryColor);
}

.not-scheme {
  color: #333;
}
</style>

<style lang="stylus">
/* 全局样式：弹窗内容最大高度由内部 .batch-list-wrap 承担 */
.all-major-dialog .el-dialog__body {
  /* body 自身不滚动、不限高，避免 sticky 失效 */
  padding: 0;
  overflow: visible;
}

/* 弹框标题加粗、颜色加深 */
.all-major-dialog .el-dialog__title {
  font-weight: 700;
  color: #1f1f1f;
}

/* 无 title 弹窗：header 保留足够高度，避免关闭按钮被裁切/遮挡 */
.all-major-dialog .el-dialog__header {
  position: relative;
  height: 44px;
  padding: 0;
  margin: 0;
}

.all-major-dialog .el-dialog__headerbtn {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 10;
  font-size: 18px;
}
</style>
